import React, { memo } from 'react';
import { Footer } from '../components/Footer';
const subProcessors = [{
  vendor: 'Vercel, Inc.',
  function: 'Application hosting & edge compute (frontend + API routes)',
  data: 'All Nisa request traffic; coach/teacher account metadata; transient request bodies (chat messages, file URLs); deployment logs.',
  region: 'US',
  safeguards: 'SOC 2 Type II, ISO 27001, GDPR, HIPAA-eligible'
}, {
  vendor: 'Neon, Inc.',
  function: 'Managed PostgreSQL (application DB + AI memory DB)',
  data: 'All persisted application data: users, organizations, teachers, touchpoints, coaching goals, action steps, file metadata; AI agent memory threads and embeddings.',
  region: 'US (us-east-2)',
  safeguards: 'SOC 2 Type II, GDPR, encryption at rest and in transit'
}, {
  vendor: 'Amazon Web Services, Inc. (AWS)',
  function: 'Object storage for uploads (S3) and underlying compute for Vercel / Neon / Mastra',
  data: 'Coach- and teacher-uploaded files: lesson recordings, audio, documents, images. Presigned URLs are HTTPS-only.',
  region: 'US (us-east-1)',
  safeguards: 'SOC 2, ISO 27001, FedRAMP Moderate, HIPAA-eligible'
}, {
  vendor: 'OpenAI, L.L.C.',
  function: 'LLM inference (GPT family) for the Nisa coaching agent and supporting tools',
  data: 'Chat messages, coach notes, lesson content, and other text inputs sent to the model; tool call inputs/outputs.',
  region: 'US',
  safeguards: 'SOC 2 Type II, GDPR, no training on API data, zero data retention available on request. Agreement to exclude data from training in place.'
}, {
  vendor: 'Anthropic, PBC',
  function: 'LLM inference (Claude family) for Coaching Casts and selected agent tasks',
  data: 'Coach-provided notes, lesson content, and coaching log excerpts used to generate audio coaching content.',
  region: 'US',
  safeguards: 'SOC 2 Type II, GDPR, no training on API data. Agreement to exclude data from training in place.'
}, {
  vendor: 'Google LLC (Gemini API / Vertex AI)',
  function: 'Supplemental LLM inference',
  data: 'Same categories as OpenAI/Anthropic above.',
  region: 'US',
  safeguards: 'SOC 2, ISO 27001, GDPR; Agreement to exclude data from training in place.'
}, {
  vendor: 'Langfuse GmbH',
  function: 'LLM observability and tracing (us.cloud.langfuse.com)',
  data: 'Agent traces: prompts, completions, tool calls, latency, user ID, thread ID. May contain coach-entered text.',
  region: 'US (us.cloud.langfuse.com)',
  safeguards: 'SOC 2 Type II in progress, GDPR, encryption at rest and in transit'
}, {
  vendor: 'PostHog, Inc.',
  function: 'Product analytics, session metadata, feature flags',
  data: 'Pseudonymous app usage events, user IDs, page views, feature interactions, error events. No chat content.',
  region: 'US (us.i.posthog.com)',
  safeguards: 'SOC 2 Type II, GDPR, HIPAA BAA available'
}, {
  vendor: 'Twilio, Inc. (SendGrid)',
  function: 'Transactional email (invitations, onboarding, password resets, support notifications)',
  data: 'Recipient names and email addresses; email subject and body; delivery metadata. Limited marketing list IDs for product news.',
  region: 'US',
  safeguards: 'SOC 2 Type II, ISO 27001, GDPR, HIPAA BAA available'
}, {
  vendor: 'Twilio, Inc. (Programmable Messaging + Verify)',
  function: 'SMS messaging (chat-by-SMS) and Verify (2FA / one-time codes)',
  data: 'Phone numbers, SMS message content, verification codes, delivery metadata.',
  region: 'US',
  safeguards: 'SOC 2 Type II, ISO 27001, GDPR, HIPAA BAA available'
}, {
  vendor: 'Google LLC (Workspace OAuth, Drive, Docs, Sheets)',
  function: 'Sign-in via Google OAuth; optional read access to coaching log documents the coach explicitly links',
  data: 'Google account email and profile; document content of coach-linked files (read-only via Drive API).',
  region: 'US (global infrastructure)',
  safeguards: 'SOC 2, ISO 27001, GDPR, FedRAMP'
}];
export const SubProcessors = () => {
  return <div className="flex flex-col min-h-screen" data-id="element-1000">
      <main className="py-section-mobile md:py-section-desktop relative flex-grow overflow-hidden" data-id="element-1001">
        {/* Background pattern */}
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-1002" />
        {/* XL Cyan gradient blob */}
        <div className="absolute -left-[300px] top-[10%] w-[1400px] h-[1400px] bg-gradient-to-tr from-cyan-500/15 via-primary-300/10 to-cyan-200/15 rounded-[50%_50%_45%_55%] blur-3xl -z-10" data-id="element-1003" />
        {/* Floating gradient blobs */}
        <div className="absolute top-0 right-1/3 w-[900px] h-[900px] bg-gradient-to-br from-cyan-400/10 via-teal-400/10 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-1004" />
        <div className="absolute top-[30%] -left-[200px] w-[800px] h-[800px] bg-gradient-to-tr from-purple-400/10 via-violet-400/10 to-fuchsia-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-1005" />
        <div className="absolute top-[60%] right-0 w-[750px] h-[750px] bg-gradient-to-bl from-amber-400/10 via-orange-400/10 to-red-400/10 rounded-[55%_45%_60%_40%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-1006" />
        <div className="absolute bottom-0 left-1/4 w-[700px] h-[700px] bg-gradient-to-r from-emerald-400/10 via-green-400/10 to-teal-400/10 rounded-[45%_55%_50%_50%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '3s'
      }} data-id="element-1007" />
        {/* Content container */}
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1008">
          <h1 className="text-4xl md:text-5xl font-serif font-normal text-cyan-900 mb-6 text-center" data-id="element-1009">
            Nisa Sub-processors
          </h1>

          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-1010">
            <p className="text-gray-500 mb-8" data-id="element-1011">Last Updated: June 2026</p>

            <p className="mb-6 text-gray-700 leading-relaxed" data-id="element-1012">
              Nisa engages and uses third party sub-processors
              ("Sub-processors") to help us provide the Services.
            </p>
            <p className="mb-6 text-gray-700 leading-relaxed" data-id="element-1013">
              Sub-processors provide infrastructure, data storage, system
              logging services, and other tools that facilitate the delivery of
              the Services including customer support and email communications.
              These Sub-processors may be provided access to Customer Content
              and Mentions that may contain information about individuals,
              however they are only permitted to use this information to support
              the Services.
            </p>
            <p className="mb-8 text-gray-700 leading-relaxed" data-id="element-1014">
              As part of Nisa's commitment to keep your data secure, we evaluate
              our Sub-processors' privacy and security practices prior to
              engaging them. We also require our Sub-processors to enter into
              data processing agreements that maintain the confidentiality of
              your data and incorporate data protection obligations consistent
              with applicable privacy laws.
            </p>

            <h2 className="text-2xl font-serif font-normal text-gray-600 mb-4" data-id="element-1015">
              Sub-processors
            </h2>

            {/* Table (scrolls horizontally on small screens) */}
            <div className="overflow-x-auto -mx-2 sm:mx-0" data-id="element-1016">
              <table className="w-full min-w-[720px] border-collapse text-sm" data-id="element-1017">
                <thead data-id="element-1018">
                  <tr className="text-left text-gray-800 border-b border-gray-200" data-id="element-1019">
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-1020">
                      Vendor
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-1021">
                      Function
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-1022">
                      Data processed
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-1023">
                      Region
                    </th>
                    <th className="py-3 px-3 font-semibold align-bottom" data-id="element-1024">
                      Safeguards / certifications
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1025">
                  {subProcessors.map(sp => <tr key={sp.vendor} className="border-b border-gray-100 align-top text-gray-700" data-id="element-1026">
                      <td className="py-4 px-3 font-medium text-gray-800 whitespace-normal" data-id="element-1027">
                        {sp.vendor}
                      </td>
                      <td className="py-4 px-3 leading-relaxed" data-id="element-1028">
                        {sp.function}
                      </td>
                      <td className="py-4 px-3 leading-relaxed" data-id="element-1029">{sp.data}</td>
                      <td className="py-4 px-3 whitespace-nowrap" data-id="element-1030">
                        {sp.region}
                      </td>
                      <td className="py-4 px-3 leading-relaxed" data-id="element-1031">
                        {sp.safeguards}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <h2 className="text-2xl font-serif font-normal text-gray-600 mt-10 mb-4" data-id="element-1032">
              Updates
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1033">
              In the event Nisa adds or removes Sub-processors, Nisa will post
              such updates at{' '}
              <a href="/security" className="text-cyan-600 hover:text-cyan-700 underline underline-offset-2" data-id="element-1034">
                nisa.coach/security
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-1035" />
    </div>;
};